import React from "react";

const Close: React.FC = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM9.56669 5.28037L7.91851 6.92856L9.56669 8.57674C9.84101 8.85107 9.8437 9.29315 9.56842 9.56842C9.29506 9.84179 8.85331 9.84326 8.57674 9.56669L6.92856 7.91851L5.28037 9.56669C5.00605 9.84101 4.56397 9.8437 4.28869 9.56842C4.01533 9.29506 4.01386 8.85331 4.29042 8.57674L5.93861 6.92856L4.29042 5.28037C4.0161 5.00605 4.01342 4.56397 4.28869 4.28869C4.56206 4.01533 5.00381 4.01386 5.28037 4.29042L6.92856 5.93861L8.57674 4.29042C8.85107 4.0161 9.29315 4.01342 9.56842 4.28869C9.84179 4.56206 9.84326 5.00381 9.56669 5.28037Z"
        fill="white"
      />
    </svg>
  );
};

export default Close;
